export default function (currency) {
  
  return {
    money: {
      style: 'currency',
      currency,
    },

    moneyRounded: {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
    },

    // No currency symbol or group separators "12345.00"
    moneyCSV: {
      style: 'decimal',
      useGrouping: false,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      postProcessors: [
        { test: ",", flags: 'g', replace: "." }, // replace ',' with '.' 123,00 => 123.00
      ],
    },

    simple: {
    	minimumFractionDigits: 0,
    	maximumFractionDigits: 4,
    },
  }

}